(() => {
  const selectors = {
    optionInput: 'input[name="purchase_option"][data-selling-plan-id]',
    optionGroup: '.md-pdp__purchase-options, .md-product-pdp__purchase-options',
    optionLabel: '.md-pdp__purchase-option, .md-product-pdp__purchase-option',
    planInput: '[data-selling-plan-input]',
    price: '[data-product-price]',
    comparePrice: '[data-product-compare]',
    submitPrice: '[data-product-submit-price]',
  };

  function getProductRoot(node) {
    return node.closest('.md-pdp, .md-product-pdp');
  }

  function updateSellingPlanUrl(input) {
    if (!getProductRoot(input)) return;

    const sellingPlanId = input.dataset.sellingPlanId || '';
    const url = new URL(window.location.href);

    if (sellingPlanId) {
      url.searchParams.set('selling_plan', sellingPlanId);
    } else {
      url.searchParams.delete('selling_plan');
    }

    if (url.toString() !== window.location.href) {
      window.history.replaceState(window.history.state, '', url.toString());
    }
  }

  function updatePurchaseOption(input) {
    const group = input.closest(selectors.optionGroup);
    if (!group) return;

    group.querySelectorAll(selectors.optionLabel).forEach((label) => {
      const selected = label.contains(input) && input.checked;
      label.classList.toggle('md-pdp__purchase-option--selected', selected);
      label.classList.toggle(
        'md-product-pdp__purchase-option--selected',
        selected,
      );
    });

    const form = input.closest('form');
    const planInput = form?.querySelector(selectors.planInput);
    if (planInput) planInput.value = input.dataset.sellingPlanId || '';

    const submitPrice = form?.querySelector(selectors.submitPrice);
    if (submitPrice && input.dataset.purchaseOptionPrice) {
      submitPrice.textContent = input.dataset.purchaseOptionPrice;
    }

    const productRoot = getProductRoot(input);
    const price = productRoot?.querySelector(selectors.price);
    if (
      price?.dataset.useSubscriptionPrice !== 'false' &&
      input.dataset.purchaseOptionPrice
    ) {
      price.textContent = input.dataset.purchaseOptionPrice;

      const comparePrice = productRoot.querySelector(selectors.comparePrice);
      const comparePriceValue = input.dataset.sellingPlanId
        ? price.dataset.oneTimePrice || ''
        : price.dataset.oneTimeComparePrice || '';
      if (comparePrice) {
        comparePrice.hidden = !comparePriceValue;
        comparePrice.textContent = comparePriceValue;
      }
    }

    updateSellingPlanUrl(input);

    document.dispatchEvent(
      new CustomEvent('medistik:purchase-option:change', {
        bubbles: true,
        detail: {
          form,
          input,
          sellingPlanId: input.dataset.sellingPlanId || '',
          price: input.dataset.purchaseOptionPrice || '',
        },
      }),
    );
  }

  const regionRequestByToken = new Map();

  function cachedRegion() {
    try {
      return window.sessionStorage.getItem('medistik-region') || '';
    } catch (error) {
      return '';
    }
  }

  function cacheRegion(region) {
    try {
      window.sessionStorage.setItem('medistik-region', region);
    } catch (error) {
      return;
    }
  }

  function fetchRegion(token) {
    const cached = cachedRegion();
    if (cached) return Promise.resolve(cached);
    if (!token) return Promise.resolve('');
    if (regionRequestByToken.has(token)) return regionRequestByToken.get(token);

    const request = fetch(`https://ipinfo.io/json?token=${encodeURIComponent(token)}`)
      .then((response) => {
        if (!response.ok) throw new Error('Region request failed');
        return response.json();
      })
      .then((location) => {
        const region = location.region || '';
        if (region) cacheRegion(region);
        return region;
      })
      .catch(() => '');

    regionRequestByToken.set(token, request);
    return request;
  }

  function applyQuebecRestriction(form, restricted) {
    const root = getProductRoot(form);
    const cta = root?.querySelector('[data-quebec-purchase-cta]');
    if (!root || !cta) return;

    root.classList.add('md-product--quebec-restricted');
    root.classList.toggle('md-region--quebec', restricted);
    form.hidden = restricted;
    cta.hidden = !restricted;

    form.querySelectorAll('button, input, select').forEach((control) => {
      if (restricted) {
        if (!('quebecWasDisabled' in control.dataset)) {
          control.dataset.quebecWasDisabled = control.disabled ? 'true' : 'false';
        }
        control.disabled = true;
      } else {
        if (control.dataset.quebecWasDisabled === 'false') {
          control.disabled = false;
        }
        delete control.dataset.quebecWasDisabled;
      }
    });

    document.body.classList.add('md-product--quebec-restricted');
    document.body.classList.toggle('md-region--quebec', restricted);
    document.body.classList.add('md-region-ready');
  }

  function initializeQuebecRestriction(form) {
    if (form.dataset.quebecRestricted !== 'true') return;

    const root = getProductRoot(form);
    root?.classList.add('md-product--quebec-restricted');
    document.body.classList.add('md-product--quebec-restricted');

    fetchRegion(form.dataset.regionIpinfoToken || '').then((region) => {
      applyQuebecRestriction(form, String(region).toLowerCase() === 'quebec');
    });
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches(selectors.optionInput)) return;
    updatePurchaseOption(input);
  });

  document
    .querySelectorAll(`${selectors.optionInput}:checked`)
    .forEach((input) => updatePurchaseOption(input));

  document
    .querySelectorAll('form[data-quebec-restricted="true"]')
    .forEach((form) => initializeQuebecRestriction(form));

  window.MedistikPurchaseOptions = {
    update: updatePurchaseOption,
  };
})();
